import Profile from "../../../../pages/Config/Profiles";
import ProfileNewEdit from "../../../../pages/Config/Profiles/NewEdit";

const routerProfile = [
    {
        key: "userProfile",
        path: "/config/userProfile",
        element: <Profile />,
    },
    {
        key: "userProfile",
        path: "/config/userProfile/new",
        element: <ProfileNewEdit />,
    },
    {
        key: "userProfile",
        path: "/config/userProfile/:id",
        element: <ProfileNewEdit />,
    },
]

export default routerProfile
